(() => {
  const sections = document.querySelectorAll('[data-bud-use]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach((section) => {
    const board = section.querySelector('[data-bud-use-board]');
    const cards = Array.from(section.querySelectorAll('[data-bud-use-card]'));
    const lines = Array.from(section.querySelectorAll('[data-bud-use-line]'));

    if (!board || cards.length < 3 || lines.length < 2) return;

    let frame = null;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const pointForNumber = (card, boardRect) => {
      const number = card.querySelector('.bud-use__number');
      const rect = number ? number.getBoundingClientRect() : card.getBoundingClientRect();
      const x = rect.left - boardRect.left + rect.width * 0.5;
      const y = rect.top - boardRect.top + rect.height * 0.5;
      return { x, y };
    };

    const updateLines = () => {
      const boardRect = board.getBoundingClientRect();
      board.querySelector('.bud-use__connectors')?.setAttribute('viewBox', `0 0 ${boardRect.width} ${boardRect.height}`);

      lines.forEach((line, index) => {
        const start = pointForNumber(cards[index], boardRect);
        const end = pointForNumber(cards[index + 1], boardRect);
        const vertical = Math.max(1, end.y - start.y);
        const bow = Math.max(118, Math.min(190, boardRect.width * 0.17));
        const sideX = Math.min(start.x, end.x) - bow;
        const controls = {
          x1: sideX,
          y1: start.y + vertical * 0.24,
          x2: sideX,
          y2: end.y - vertical * 0.24,
        };
        const d = [
          `M ${start.x.toFixed(1)} ${start.y.toFixed(1)}`,
          `C ${controls.x1.toFixed(1)} ${controls.y1.toFixed(1)},`,
          `${controls.x2.toFixed(1)} ${controls.y2.toFixed(1)},`,
          `${end.x.toFixed(1)} ${end.y.toFixed(1)}`,
        ].join(' ');

        line.setAttribute('d', d);
      });
    };

    const render = () => {
      currentX += (targetX - currentX) * 0.13;
      currentY += (targetY - currentY) * 0.13;

      cards.forEach((card) => {
        const depthX = Number(card.dataset.depthX || 0);
        const depthY = Number(card.dataset.depthY || 0);
        card.style.setProperty('--bud-step-x', `${(currentX * depthX).toFixed(2)}px`);
        card.style.setProperty('--bud-step-y', `${(currentY * depthY).toFixed(2)}px`);
      });

      updateLines();

      if (Math.abs(targetX - currentX) > 0.002 || Math.abs(targetY - currentY) > 0.002) {
        frame = requestAnimationFrame(render);
      } else {
        frame = null;
      }
    };

    const start = () => {
      if (!frame) frame = requestAnimationFrame(render);
    };

    if (!prefersReducedMotion) {
      section.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;

        const rect = section.getBoundingClientRect();
        targetX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        targetY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
        section.classList.add('bud-use--active');
        start();
      });

      section.addEventListener('pointerleave', () => {
        targetX = 0;
        targetY = 0;
        section.classList.remove('bud-use--active');
        start();
      });
    }

    updateLines();

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateLines);
      observer.observe(board);
      cards.forEach((card) => observer.observe(card));
    } else {
      window.addEventListener('resize', updateLines);
    }

    window.addEventListener('load', updateLines, { once: true });
  });
})();
